import React, { useState } from 'react'
import { IconButton, Typography } from '@mui/material'
import { J2Download } from '@e3dc-react/icons'
import { makeStyles } from 'tss-react/mui'
import { BlankContract } from '../../models/power-meter.model'

interface ShopDownloadButtonProps {
  contractDetails: BlankContract
}

const useStyles = makeStyles()(theme => ({
  documentButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    width: 'max-content',
    minWidth: theme.spacing(6),
    maxWidth: theme.spacing(6),
    height: theme.spacing(6),
    boxSizing: 'border-box',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    transition: 'max-width 0.5s ease-in-out',
    border: `1px solid ${theme.palette.buttonGroup.iconColor}`,
    borderRadius: theme.shape.borderRadius,

    '&:hover': {
      maxWidth: '280px',
    },
  },
  hovered: {
    maxWidth: '280px',
  },
  text: {
    flexShrink: 0,
    maxWidth: '220px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  icon: {
    flexShrink: 0,
  },
}))

/*
 * This is a download button for contracts of smart meters
 */
const ShopDownloadButton: React.FC<ShopDownloadButtonProps> = ({ contractDetails }) => {
  const { classes, cx } = useStyles()
  const [isHovered, setIsHovered] = useState(false)

  const contractUrl = contractDetails.link
  const contractName = `${contractDetails?.fileName}.${contractDetails?.fileExtension ?? ''}`

  return (
    <IconButton
      onClick={() => {
        window.open(contractUrl, '_blank')
      }}
      color="inherit"
      className={cx(classes.documentButton, { [classes.hovered]: isHovered })}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <J2Download fontSize="medium" color="primary" className={classes.icon} />
      <Typography variant="subtitle2" className={classes.text}>
        {contractName}
      </Typography>
    </IconButton>
  )
}

export default ShopDownloadButton
